let canvas: HTMLDivElement;

export function setCanvas(c: HTMLDivElement) {
  canvas = c;
}

export function getCanvas() {
  return canvas;
}
